module.exports = __webpack_public_path__ + "img/order_not_fund.3326f8ec.png";